import React, { createContext, Dispatch, useContext, useReducer, useMemo } from "react";
import { SharedMaterialsState, SharedMaterialsStateActionType } from "./interfaces";
import initialSharedMaterialsState from "./initialSharedMaterialsState";
import SharedMaterialsStateReducer from "./sharedMaterialsStateReducer";

export const SharedMaterialsStateContext = React.createContext<{
    sharedMaterialsState: SharedMaterialsState
    dispatch: Dispatch<SharedMaterialsStateActionType>
  }>({ sharedMaterialsState: initialSharedMaterialsState, dispatch: () => initialSharedMaterialsState })

const { Provider } = SharedMaterialsStateContext

interface SharedMaterialsStateProviderProps {
    children: React.ReactNode
}

export type SharedMaterialsStateReducerType = (
  state: SharedMaterialsState,
  action: SharedMaterialsStateActionType
) => SharedMaterialsState

const SharedMaterialsStateProvider: React.FC<SharedMaterialsStateProviderProps> = ({
  children,
}) => {
  const [sharedMaterialsState, dispatch] = useReducer<SharedMaterialsStateReducerType>(
    SharedMaterialsStateReducer,
    initialSharedMaterialsState
  )

  const contextValue = useMemo(() => ({ sharedMaterialsState, dispatch }), [
    sharedMaterialsState,
    dispatch,
  ])

  return <Provider value={contextValue}>{children}</Provider>
}

export default SharedMaterialsStateProvider





